import { createContext, useCallback, useEffect, useMemo, useState } from "react";
import { SideNavContextValue } from "../../types/sideNav";

export const SideNavMenuContext = createContext<SideNavContextValue | undefined>(
  undefined,
);

export const SideNavMenuProvider: React.FC<{
  children?: React.ReactNode;
  initIsOpen?: boolean;
  controlledIsOpen?: boolean;
  reopenKey?: string;
}> = ({ children, initIsOpen = false, controlledIsOpen, reopenKey }) => {
  const [isOpen, setIsOpen] = useState(initIsOpen);
  const toggleIsOpen = useCallback(() => setIsOpen((open) => !open), []);

  useEffect(() => {
    if (controlledIsOpen) {
      setIsOpen(true);
    }
  }, [controlledIsOpen, reopenKey]);

  const contextValue = useMemo<SideNavContextValue>(
    () => ({
      isOpen,
      setIsOpen,
      toggleIsOpen,
    }),
    [isOpen, toggleIsOpen],
  );

  return (
    <SideNavMenuContext.Provider value={contextValue}>
      {children}
    </SideNavMenuContext.Provider>
  );
};
